export default "__VITE_ASSET__BepmMWue__"